module.exports = __webpack_public_path__ + "img/girls-education.648be287.png";